import { renderToStaticMarkup } from 'react-dom/server';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { delatexify } from 'src/components/markdown/delatexify';

/**
 * Convert the assistant's Markdown notes (same style as chat responses) into HTML
 * for the Quill "Notatki" editor, which stores HTML and supports
 * header/list/bold/italic/strike formats. Runs the LaTeX sanitizer first so any
 * leaked $\gamma$-style tokens become Unicode. Produces plain semantic HTML
 * (no MUI Typography wrappers) so Quill parses it into its own formats.
 */
export function markdownToEditorHtml(markdown: string): string {
  if (!markdown) return '';
  return renderToStaticMarkup(
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{delatexify(markdown)}</ReactMarkdown>,
  );
}
